/**
 * @author: Radim Buráň <xburan03@stud.fit.vutbr.cz>
 */

import './UserRegisterConfirm.css';

import {useEffect} from "react";
import { useState } from "react";
import { Fragment } from "react";

import {Box, createTheme, IconButton, lighten, Paper} from "@mui/material";
import { makeStyles } from '@mui/styles';
import {DataGrid, GridRenderCellParams} from "@mui/x-data-grid";
import Button from "@mui/material/Button";
import DoneIcon from '@mui/icons-material/Done';
import {DoNotDisturb} from "@mui/icons-material";
import {getFrom, patchTo} from "../../data/api";
import { useNavigate } from "react-router-dom";

function UserRegisterConfirm(props) {
    const [rows, setRows] = useState([])
    const navigate = useNavigate()

    useEffect(()=> {
        fetchRegisteredUsers();
    },[])

    function fetchRegisteredUsers() {
        getFrom('/registeredUsers/')
            .then((res)=> {
                if (res.status === 200) {
                    updateRows(res.data);
                }
            }).catch((e)=>{
            console.error(e);
        })
    }

    function updateRows(regUsers) {
        const result = [];
        for (let i = 0; i < regUsers.length; ++i) {
            let rUser = regUsers[i];
            result.push({
                id: rUser.id,
                state: rUser.state,
                name: rUser.user.name,
                email: rUser.user.email,
                registered: new Date(rUser.user.createdAt).toLocaleString('cs-CZ'),
                auction: {
                    id: rUser.auction.id,
                    title: rUser.auction.title
                },
                date: new Date(rUser.createdAt).toLocaleString('cs-CZ')
            });
        }
        setRows(result);
    }


    function changeAuctionState(id, newState) {
        patchTo('/registeredUsers/', {
            id: Number(id),
            state: newState
        }).then((res)=> {
                if (res.status === 200) {
                    fetchRegisteredUsers();
                }
        }).catch((e)=>{
            console.error(e);
        })
    }

    function getTranslatedState(state) {
        if (state === "APPROVED") {
            return "Schváleno";
        }
        else if (state === "DENIED") {
            return "Zamítnuto";
        }
        else {
            return "Čekání"
        }
    }

    const columns = [
        { field: 'id', headerName: 'ID', width: 90, hide: true },
        { field: 'name', headerName: 'Jméno', width: 200 },
        { field: 'email', headerName: 'Email', width: 240 },
        { field: 'registered', headerName: 'Registrován', width: 200 },

        { field: 'state', headerName: 'Stav', width: 100,
            renderCell: (params) => (
                <Fragment>
                    {getTranslatedState(params.value)}
                </Fragment>
            )},

        { field: 'stateButtons', headerName: '', width: 85,
            renderCell: (params) => (
                <Box sx={{marginLeft: -1}}>
                    {params.row.state !== "APPROVED" &&
                        <IconButton color="success"
                                    onClick={() => changeAuctionState(params.getValue(params.id, 'id'), "APPROVED")}>
                            <DoneIcon/>
                        </IconButton>
                    }
                    {params.row.state !== "DENIED" &&
                        <IconButton color="error"
                                    onClick={() => changeAuctionState(params.getValue(params.id, 'id'), "DENIED")}>
                            <DoNotDisturb/>
                        </IconButton>
                    }
                </Box>
            )},

        { field: 'date', headerName: 'Požádáno', width: 200 },

        { field: 'auction', headerName: 'Aukce', width: 250,
            renderCell: (params) => (
                <Fragment>
                    <Button variant="contained" color="primary" size="small" style={{ marginRight: 16 }}
                    onClick={() => navigate('/auctions/' + params.value.id)}>
                        Detail
                    </Button>
                    {params.value.title}
                </Fragment>
        )},
    ];

    const classes = useStyles();

    return (
        <div className="user-reg-confirm">
            <Paper elevation={6} sx={{ padding: 2 }}>
                <DataGrid autoHeight className={classes.root}
                          pageSize={20}
                          rowsPerPageOptions={[20]}
                          disableSelectionOnClick
                          rows={rows}
                          columns={columns}
                          getRowClassName={(params) =>
                              `grid-style--${params.getValue(params.id, 'state')}`}
                />

            </Paper>
        </div>
    );
}



const defaultTheme = createTheme();

const useStyles = makeStyles(
    (theme) => {
        const getBackgroundColor = (color) =>
            lighten(color, 0.6);

        const getHoverBackgroundColor = (color) =>
            lighten(color, 0.5);

        return {
            root: {
                '& .grid-style--WAITING': {
                    backgroundColor: getBackgroundColor(theme.palette.warning.main),
                    '&:hover': {
                        backgroundColor: getHoverBackgroundColor(theme.palette.warning.main),
                    },
                },
                '& .grid-style--APPROVED': {
                    backgroundColor: getBackgroundColor(theme.palette.success.main),
                    '&:hover': {
                        backgroundColor: getHoverBackgroundColor(theme.palette.success.main),
                    },
                },
                '& .grid-style--DENIED': {
                    backgroundColor: getBackgroundColor(theme.palette.error.main),
                    '&:hover': {
                        backgroundColor: getHoverBackgroundColor(theme.palette.error.main),
                    },
                },
            },
        };
    },
    { defaultTheme },
);



export default UserRegisterConfirm;











